import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    useEffect(()=>{
        // _swat.initializeActionButtons(".ns-serp")
    })

    return (
        <div class="collection">
            <product-list id="product-list-template--17215969132642__main" class="product-list" per-page="36" collection-mobile-layout="medium" collection-desktop-layout="medium">
                {products.hits.map((hit, index) => {
                    return <Product product={hit} key={hit.productId || index} />
                })}
            </product-list>
        </div>
    )
}
